import { render, staticRenderFns } from "./BlockTools.vue?vue&type=template&id=52325b45"
import script from "./BlockTools.vue?vue&type=script&lang=js"
export * from "./BlockTools.vue?vue&type=script&lang=js"
import style0 from "./BlockTools.vue?vue&type=style&index=0&id=52325b45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports